import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Send = forwardRef<SVGSVGElement, SvgIconProps>(function Send(props, ref) {
  return (
    <SvgIcon ref={ref} {...props}>
      <path
        d="M3.4 20.8849L20.85 13.4049C21.66 13.0549 21.66 11.9149 20.85 11.5649L3.4 4.08488C2.74 3.79488 2.01 4.28488 2.01 4.99488L2 9.60488C2 10.1049 2.37 10.5349 2.87 10.5949L13.8964 12.5L2.87 14.3649C2.37 14.4349 2 14.8649 2 15.3649L2.01 19.9749C2.01 20.6849 2.74 21.1749 3.4 20.8849Z"
        fill="#918D8D"
      />
    </SvgIcon>
  )
})

export default Send
